// Central configuration for frontend upload limits
export const UPLOAD_LIMITS = {
    // Max file size in bytes (default; overridden by /config)
    MAX_SIZE_BYTES: 20 * 1024 * 1024,

    // Max resolution for Library Tiles (100 MP)
    // e.g., 10,000 x 10,000 px
    MAX_TILE_PIXELS: 100 * 1_000_000,

    // Max resolution for Main Target Photo (500 MP)
    // e.g., 22,000 x 22,000 px
    MAX_TARGET_PIXELS: 500 * 1_000_000
};

export function applyUploadLimitsPolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.max_file_size_bytes != null) {
        const val = Math.max(0, Number(policy.max_file_size_bytes));
        if (!Number.isNaN(val) && val > 0) {
            UPLOAD_LIMITS.MAX_SIZE_BYTES = val;
        }
    } else if (policy.max_file_size_mb != null) {
        const val = Math.max(0, Number(policy.max_file_size_mb)) * 1024 * 1024;
        if (!Number.isNaN(val) && val > 0) {
            UPLOAD_LIMITS.MAX_SIZE_BYTES = val;
        }
    }
    if (policy.max_tile_pixels != null) {
        const val = Math.max(0, Number(policy.max_tile_pixels));
        if (!Number.isNaN(val) && val > 0) {
            UPLOAD_LIMITS.MAX_TILE_PIXELS = val;
        }
    }
    if (policy.max_target_pixels != null) {
        const val = Math.max(0, Number(policy.max_target_pixels));
        if (!Number.isNaN(val) && val > 0) {
            UPLOAD_LIMITS.MAX_TARGET_PIXELS = val;
        }
    }
}
